function Row() {
  return (
    <div className="flex items-center gap-4 border-b border-line px-2 py-3 last:border-b-0">
      <div className="h-10 w-10 animate-pulse rounded-full bg-surface" />
      <div className="flex-1 space-y-2">
        <div className="h-4 w-1/3 animate-pulse rounded bg-surface" />
        <div className="h-3 w-1/4 animate-pulse rounded bg-surface" />
      </div>
      <div className="h-6 w-20 animate-pulse rounded-full bg-surface" />
      <div className="h-6 w-20 animate-pulse rounded-full bg-surface" />
    </div>
  )
}

export function UsersTableSkeleton({ count = 4 }: { count?: number }) {
  return (
    <div>
      {Array.from({ length: count }, (_, i) => (
        <Row key={i} />
      ))}
    </div>
  )
}
